import React, { Component } from 'react';
import PropTypes from 'prop-types';
import NumberUtils from '../../utils/NumberUtils';

class DonutChart extends Component {
  constructor(props) {
    super(props);

    this.state = {
      value: 0,
    };
  }

  componentDidMount() {
    setTimeout(() => {
      this.setState(() => ({
        value: this.props.value,
      }));
    }, 100);
  }

  render() {
    const halfsize = this.props.size * 0.5;
    const radius = halfsize - this.props.strokewidth * 0.5;
    const circumference = 2 * Math.PI * radius;
    const strokeval = (this.props.value * circumference) / 100;
    const dashval = `${strokeval} ${circumference}`;

    const trackstyle = { strokeWidth: this.props.strokewidth };
    const indicatorstyle = {
      strokeWidth: this.props.strokewidth,
      strokeDasharray: dashval,
    };
    const transformRotate = `rotate(-90 ${halfsize},${halfsize})`;

    return (
      <svg
        width="100%"
        height="100%"
        className="donutchart"
        viewBox={`0 0 ${this.props.size} ${this.props.size}`}
      >
        <circle
          r="46%"
          cx={halfsize}
          cy={halfsize}
          transform={transformRotate}
          style={trackstyle}
          className="donutchart-track"
        />
        <circle
          r="46%"
          cx={halfsize}
          cy={halfsize}
          transform={transformRotate}
          style={indicatorstyle}
          className="donutchart-indicator"
        />
        <text
          className="donutchart-text"
          x={halfsize + 5}
          y={halfsize + 15}
          style={{ textAnchor: 'middle' }}
        >
          <tspan className="donutchart-text-val">
            {NumberUtils.formatAmount(Number(this.props.value))}
          </tspan>
          <tspan className="donutchart-text-percent">%</tspan>
        </text>
      </svg>
    );
  }
}

DonutChart.defaultProps = {
  value: 0,
  size: 200,
  strokewidth: 14,
};

DonutChart.propTypes = {
  value: PropTypes.number, // value the chart should show
  valuelabel: PropTypes.string, // label for the chart
  size: PropTypes.number, // diameter of chart
  strokewidth: PropTypes.number, // width of chart line
  strokelinecap: PropTypes.string,
};

export { DonutChart };
